import { useTranslation } from "react-i18next";
import InfoFlyUpModal from "../../../InfoFlyUpModal/index";
import InfoModal from "../../../InfoFlyUpModal/components/InfoModal";

export interface MyHeartRateModalProps {
  isOpen?: boolean;
  onClose?: () => void;
}

export default function MyHeartRateModal({
  isOpen,
  onClose,
}: MyHeartRateModalProps = {}) {
  const { t } = useTranslation();

  const modalProps = {
    title: t("HealthChart.myHeartRateModal.title"),
    description: t("HealthChart.myHeartRateModal.description"),
    importanceTitle: t("HealthChart.myHeartRateModal.importance.title"),
    unorderedList: t("HealthChart.myHeartRateModal.range", {
      returnObjects: true,
    }),
    textList: t("HealthChart.myHeartRateModal.disclaimer", {
      returnObjects: true,
    }),
  };

  if (isOpen !== undefined && onClose !== undefined) {
    return (
      <InfoModal
        isOpen={isOpen}
        handleClose={onClose}
        title={modalProps.title}
        description={modalProps.description}
        importanceTitle={modalProps.importanceTitle}
        unorderedList={modalProps.unorderedList}
        textList={modalProps.textList}
      />
    );
  }

  return (
    <InfoFlyUpModal
      cardProps={{
        title: t("HealthChart.myHeartRateModal.card.title"),
        description: t("HealthChart.myHeartRateModal.card.description"),
      }}
      modalProps={modalProps}
    />
  );
}
